module.exports = __webpack_public_path__ + "static/media/figure8.3aa59423.png";